export const paymentProcess = async (type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb) => {
  const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  let denominationValue = currenciesList.length > 0 ? currenciesList[0]?.value : 1;
  // const calculateRoundingDifference = (value) => {
  //   const overpayment = value - (cart.paid ?? 0);

    // const change = Math.floor(overpayment / denominationValue) * denominationValue;
    // // Remaining amount is treated as overpayment
    // const remainingOverpayment = overpayment - change;

    // const changeAmount =
    //   (cart.paid) + parseFloat(value) - Math.abs(cart.total) > 0
    //     ? (cart.paid + parseFloat(value) - Math.abs(Math.abs(cart.total) + Math.abs(remainingOverpayment))).toFixed(2)
    //     : cart?.change <= 0
    //     ? "0.00"
    //     : cart?.change;

    // const changeAmount =
    //   (cart.paid ?? 0) + parseFloat(value) - Math.abs(cart.total) > 0
    //     ? ((cart.paid ?? 0) + parseFloat(value) - Math.abs(Math.abs(cart.total) + Math.abs(remainingOverpayment))).toFixed(2)
    //     : cart?.change <= 0
    //     ? "0.00"
    //     : cart?.change;
    // const floatAmount = parseFloat(Math.floor(changeAmount / 1).toFixed(precision));

    //setOverPayedAmount(changeAmount - floatAmount > 0 ? (changeAmount - floatAmount).toFixed(precision) : 0);
    // setOverPayedAmount(remainingOverpayment > 0 ? remainingOverpayment.toFixed(precision) : 0);
  const calculateRoundingDifference = (enteredAmount) => {
    // Respect POS rounding flag
    if (selectedPaymentMethod?.roundOffForPos !== "Y") {
      setOverPayedAmount(0);
      return;
    }

    const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];

    const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

    const remainingAmount = Math.abs(cart.total) - (cart.paid ?? 0);

    const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

    // No rounding if entered amount is less than remaining
    if (enteredAmount < remainingAmount) {
      setOverPayedAmount(0);
      return;
    }

    const roundedAmount = Math.ceil(remainingAmount / smallestDenomination) * smallestDenomination;

    const overpayment = (roundedAmount - remainingAmount).toFixed(precision);

    setOverPayedAmount(parseFloat(overpayment) > 0 ? parseFloat(overpayment) : 0);
  };

  if (type === "1") {
    if (tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N") {
      return null;
    }

    if (amount === "" && value === "x") {
      setAmount("");
    } else if (value === "x") {
      setAmount(`${amount.toString().substring(0, amount.toString().length - 1)}`);
      if (Math.abs(cart.total) <= parseFloat(`${amount.toString().substring(0, amount.toString().length - 1)}`) && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        calculateRoundingDifference(parseFloat(`${amount.toString().substring(0, amount.toString().length - 1)}`));
      } else {
        setOverPayedAmount(0);
      }
    } else if (Object.keys(selectedPaymentMethod).length > 0) {
      if (value === ".") {
        const currentAmount = numb === 0 || amount === "" ? "0" : `${amount}`;
        if (!currentAmount.includes(".")) {
          if (numb === 0) {
            setNumb(numb + 1);
          }
          setAmount(`${currentAmount}.`);
        }
      } else if (numb === 0) {
        setNumb(numb + 1);
        // setAmount(`${parseFloat(parseFloat(value).toFixed(precision))}`);
        setAmount(`${parseFloat(parseFloat(value))}`);
        if (Math.abs(cart.total) <= parseFloat(value) && selectedPaymentMethod.name.toLowerCase() === "cash") {
          calculateRoundingDifference(parseFloat(`${parseFloat(value)}`));
        } else {
          setOverPayedAmount(0);
        }
      } else {
        // Keep the composed value as a string so a trailing "." or a "0"
        // right after the decimal point isn't dropped by parseFloat on
        // every keystroke (e.g. "10." + "0" must stay "10.0", not become 10).
        const nextAmount = `${amount}${value}`;
        setAmount(nextAmount);
        let cashAmount = parseFloat(nextAmount);
        if (Math.abs(cart.total) <= cashAmount && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
          calculateRoundingDifference(cashAmount);
        } else {
          setOverPayedAmount(0);
        }
      }
    }
  } else if (type === "2") {
    if (numb === 0) {
      setNumb(numb + 1);
      setAmount(parseFloat((parseFloat(0) + parseFloat(value)).toFixed(precision)));
      if (Math.abs(cart.total) - (cart.paid ?? 0) <= value && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        calculateRoundingDifference(parseFloat(0) + parseFloat(value));
      } else {
        setOverPayedAmount(0);
      }
    } else {
      setAmount(parseFloat((parseFloat(amount !== "" ? amount : 0) + parseFloat(value)).toFixed(precision)));
      if (Math.abs(cart.total) - (cart.paid ?? 0) <= parseFloat(value) + parseFloat(amount !== "" ? amount : 0) && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        calculateRoundingDifference(parseFloat(amount !== "" ? amount : 0) + parseFloat(value));
      } else {
        setOverPayedAmount(0);
      }
    }
  } else if (type === "3") {
    let cashTotal = cart.payments.reduce((total, item) => parseFloat(total) + parseFloat(item.amount), 0);
    if (Object.keys(selectedPaymentMethod).length > 0) {
      if (Math.abs(cart.total) <= parseFloat(value) + parseFloat(cashTotal) && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        calculateRoundingDifference(parseFloat(value) + parseFloat(cashTotal));
      } else {
        setOverPayedAmount(0);
      }
      // setAmount(parseFloat(parseFloat(value).toFixed(precision)));
      setAmount(value);
    }
  }
};
